module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("I")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARIA WAITS ON ONE SIDE OF THE NEWSSTAND AND")]), _vm._v(" I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON THE OTHER")]), _vm._v(". We are trying to look casual, unhurried, but we are watching the lobby carefully. Harry Cabot walks by, a rolled "), _c('em', [_vm._v("Boston Globe")]), _vm._v(" under his arm. He is wearing his usual gray suit and olive green fishing hat, and as he passes his crepe-soled shoes squeak on the granite. Many Nibble & Kuhn partners display this kind of oddity of dress, a formal suit, for instance, under a shabby, waist-length parka, or sober pin-striped trousers that end in beige socks and scuffed penny loafers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cabot passes without looking at either of us. His face is expressionless, as if minding one’s own business were an important mark of character. He may have a thyroid condition too. Without wishing to be gratuitous there is something bug-eyed about him, how he always looks vaguely startled though always, of course, in a perfectly good-natured way. If you didn’t know who he was you might mistake him for a simpleton. He stands by the elevator doors waiting for them to open and when they do he steps forward and disappears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The lobby is now empty and we cross it, Maria and I, quickly but nonchalantly. We step into an open elevator and Maria presses the button.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v(" “Close, doggone it,” she commands.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have been sitting beside her in a small room all morning, feeling her knee against mine, catching glimpses of her face, the fragrance of her skin when I lean over to whisper advice, and it has driven me half crazy. Mercifully I seem to have had the same effect on her. As the elevator rises we begin to kiss and she holds my face in a manner that is almost rough. The ride slows and she tries to pull away but I will not release her. We are almost at a stop before I do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She breaks free and straightens her shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’re looking for trouble, bucko,” she says when she sees that no one is waiting at the doors. “We would have been gonners for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“To say nothing of the fact that someone might have told Alfonso,” I say, taunting her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t be like that,” she says. “You know how it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She goes into her office and I continue on to the men’s room. I do, indeed, know how it is. How it is is the bane of my life. My most intimate moments with her—my "), _c('em', [_vm._v("only")]), _vm._v(" intimate moments with her if you discount the rubbing knees and the incidental touches—are in the elevator. The elevator has become, for want of an alternative, our love motel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Everything else is Alfonso’s. And she’s not even married to him. Not even close.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("There have been moments in my life which I knew in an instant were significant, but none more so than when I first spoke to her. Every June a small troop of law students arrive at Nibble & Kuhn for the summer, each of them brimming with an artificial, easily punctured ease. They are given simple assignments, invited to ball games and partners’ homes for dinner, and of course are carefully watched all the time. The best ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("of them are offered permanent jobs after graduation and those who are not well, something happens to them because we never see them again. I had been through it myself seven years before. By the time Maria’s class arrived I had all but forgotten what a miserable experience it had been.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The firm distributes an amateurish brochure with photographs before the interns arrive, and I recognized her as soon as I saw her: Maria Parma. Wellesley High School. Harvard College (Art History). Columbia Law School. Her looks were unprepossessing, or at least they were then, before I paid attention. She was tall with narrow hips, straight legs, a pageboy haircut. I did not, not then, notice more. What rubbed me the wrong way was how little she seemed to be affected by the anxiety around her. Her manner was jaunty, reckless. I saw her once singing in the corridor, came across her laughing as she slapped a messenger on the arm. Perhaps, and I am not sure if I remember this accurately, I caught her hoisting her nylons behind a library stack and when she saw me she shrugged, laughed, and said something like: “What’s a girl to do?” I know I risk sounding stuffy, but it seemed to me at the time that she was not paying her dues, not starting out where everyone else had. One expected a little deference, a little sobriety.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Who knows what I was thinking?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But I did ignore her, and all summer long. I might pass her in the hallway or sit across the table from her at a meeting, but nothing more. I treated her as lightly, in short, as she seemed to be treating us.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sometime toward the end of August, on a night when I had to stay late to finish a brief, I ran into her in the copy room. She was about to use the machine and I stood back and prepared to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You go first,” she volunteered.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v(" “No,” I said. “Please finish.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No,” she insisted, taking her paper from the glass and moving out of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She pressed back against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll stand here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I may have paused for a moment but then I fed my document into the machine and pressed a billing code on the monitor. The machine whirred unevenly, snatched the paper, and then pushed it out crumpled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It did that to mine too,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You knew it would do that?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I thought I was doing it wrong. I’m new here, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You could’ve warned me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’ve never told me your name,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I told her then, but with an edge of coldness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m Maria,” she said, and held out her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She had olive green eyes, tawny hair, and very white, straight teeth. As I say, I had hardly seen her before that moment. Her hand was quite warm, soft.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’ve ruined my document,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“"), _c('em', [_vm._v("I’ve")]), _vm._v(" ruined your document?” she exclaimed. “Why is it, do you think, that boys always blame someone else when they break a machine?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You broke this machine before I got here,” I said, and then I remember laughing because there seemed no other thing to do. Her eyes were filled with challenge, and as I tried to straighten the damaged paper I knew that she was watching me. I also knew, instantly, that I wanted something more of her, that there was chemistry between us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Where do you go to law school?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Columbia.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did you have a good summer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did you?”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Much later, after she had gone back to complete her studies and then returned to the firm, after months of clever patter between us as we discussed ordinary matters in a manner laced with pretense and ambiguity, we both agreed that something extraordinary, entirely physical, entirely unsaid, had passed between us that night. And when she returned suntanned after a month in Spain, her hair longer, as offbeat and jaunty as before, I was thrilled to see that she had been assigned an office near mine.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If I wanted an office romance in the year I was up for partner, there was not much more I needed to help me drift into one. Nobody would dispute that this would not have been a good idea.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To my dismay, as I enter the men’s room I see Cabot, still in his green hat, standing at the urinal. His head is tilted back and he is staring up, perhaps examining the ceiling tiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Had time for any fishing lately?” he asks when he notices me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Not really,” I say. “How about yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Caught a marlin off Key West early in the summer,” he says. “I’ve told you about that, haven’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Twice,” I answer, and we both laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among fishermen, apparently, it is acceptable to be vaguely disrespectful, even to a senior partner who is urinating, on the subject of boring others with fishing stories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s a good story, though,” I add quickly, just to be safe. “And you never brought in the photographs you said you had.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Got to remember to do that,” he says as he zips his fly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I watch him walk to the washstand and begin the process of brushing his teeth. I look away. This is something I don’t need to see.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One has to wonder whether anyone would ever set out to name a business, let alone a law firm, Nibble & Kuhn. The people who run the place seem to think nothing of it, to accept the cartoon name as quaint and historic, even "), _c('em', [_vm._v("valuable")]), _vm._v(". And if Alfred Nibble and Lionel Kuhn once practiced law together, and a hundred and ten years later the firm they founded still exists, who will take issue with the continued use of their names? It would be childish to giggle. The name in context is no more remarkable than that of the Smuckers’ whose jelly is a staple, or that of the Philadelphia Mayflower family who rejoice in the name of Biddle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nibble & Kuhn may seem at first glance to be just another old law firm, indistinct except for the oddness of its name, mired in tradition, as seamless and hidebound as an institution can possibly be. To outsiders such an impression would be almost compelled. But it is not an accurate picture and does not do justice to the firm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Take Harry Cabot, for instance, he with the green fishing hat and loping, distracted walk. I interviewed with him when I first applied for a job here, back before I knew anything about him. What I remember most vividly about the interview is not Cabot himself but the mounted fish on his wall, a great, macabre, painted thing of astonishing ugliness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did you catch that?” I remember asking, pausing to read the little brass plate below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I certainly did,” he replied proudly. “Off Marblehead. Mounted it myself, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s quite a specimen,” I said, craning my neck to examine the fish, my expression, I hoped, adequately admiring. “It must have put up quite a fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You can say that again,” Cabot said. “She fought like the dickens. Almost knocked me off my hoo hoo. But boy, when I hauled her in, how sweet it was.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I could guess from the context where Cabot’s “hoo hoo” was, but I learned afterwards that Cabot substituted “hoo hoo” for any word that was distasteful to him. To “step on your hoo hoo” meant to ask a stupid question and to be surprised by the answer. To “hand someone a bunch of hoo hoo” meant to talk nonsense, and so on. One way or another his use of the word was Harry Cabot’s notion of swearing, and it seemed as well to encapsulate his view of life; the world as a great big benign place and he, Harry Cabot, treating everyone with the same kind of genial detachment, simply along for the ride. Not surprisingly his clients were fiercely loyal to him.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Do you get to fish often?” I asked politely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Every chance I get,” he answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On the credenza behind him I saw a plastic box filled with feathery flies and two photographs in silver frames, one of a powerboat and the other of Cabot, a strikingly plain middle aged woman, and several teenage children. Attached to his office window with plastic suction cups was a plaque which read: “Boat: "), _c('em', [_vm._v("(n)")]), _vm._v(" A hole in the water surrounded by wood into which you pour money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’d love to fish again,” I said, to my lasting regret. “I haven’t had the opportunity in a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is this lie that seven years later continues to follow me. I had never been fishing in my life. I was only trying to make conversation, to find common ground with Harry Cabot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You fish?” Cabot had exclaimed. “Not many of the young fellers here do, to say nothing of the ladies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“My father used to take us every Sunday,” I think I said, or something like that, thus beginning the complex story I would have to continue. “My favorite book in high school,” I added, trying now for a measure of authenticity and a literary credit at the same time, “was "), _c('em', [_vm._v("Islands in the Stream")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I haven’t heard of that one,” Cabot said. “I like that you fish, though. In my book it shows qualities of perseverance and patience. We can always use those around here.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("When the interview was over I was left with the odd feeling that it had been too easy. It even crossed my mind that Cabot had actually disqualified me early on for some reason and was merely passing the time on irrelevancies until my half hour was up. How else could one explain the banal tone of our discussion? But before long a letter arrived offering me a summer position and I accepted the offer without hesitation. Nibble is, Nibble was, one of Boston’s leading firms. And when they offered me a permanent job at the end of the summer, I accepted that too.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Done any fishing lately?” Cabot has asked me at least once a week in the years that have followed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I always make up something, pray that no one is listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What was all that about?” Stanley Lioce asked once when he overheard us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Stanley and I shared an office as summer clerks. For whatever reason we do not see each other away from work, but he is one of the most genuine people I know. Stanley’s father hangs wall-paper in the Bronx. Mine owns a small cheese shop in Toronto. Perhaps we share something deeper than either of us knows, here among the Brahmins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh what a tangled web,” he said dryly when I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The irony is that of all the senior lawyers in the firm, I do believe Harry Cabot is the most decent. He heads the firm’s Business Law Department and runs things in a manner that leaves no room for complaint. I would have been glad to work for him forever had business law not been quite so dull. I decided early on, you see, that my life was going to be in the courtroom. I did not know then that for firms like Nibble, courtrooms are mythic and abstract places. Nibble lawyers do not try cases. Nibble lawyers threaten to try cases, and then they settle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Who knew?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("I reach my office and Kay, my secretary, comes in after me. She is a woman in her sixties who wears a little pillbox hat every day, something like the pink one Jackie was wearing the day JFK was shot. I also seem to remember that Kay used to wear white cotton gloves to work, but Stanley insists this is a figment of my imagination.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“She’d have to be mental to wear white gloves to work in this day and age,” he says. “You’re casting her in some quaint little movie you once saw.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m telling you I remember it,” I say, though in the face of his resolute ridicule I do think there is some chance, perhaps, that the white gloves are an overlay all my own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“May I speak with you, Mr. Dover?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have asked her several times to call me Derek. She has said she prefers not to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Of course,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s about the move,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mrs. Buckles insists that only the moving company can pack your office because it has to be done in a certain way, but I’m most reluctant to have a stranger rifling through your belongings.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t have anything personal here,” I say, opening a drawer to demonstrate the point. “A few paper clips. Some empty notebooks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s the principle of it,” she insists. “I never permit anyone to go through your drawers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Please, Kay,” I say. “Don’t make an issue of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well if it doesn’t bother you, I don’t see why I should take the trouble,” she says and walks out.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The firm had tripled in size since I’d arrived and by all accounts the partners were making loads of money, but there was nothing ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("about the offices themselves that suggested it. Instead, Nibble’s chipped wooden panels, mismatched college chairs, framed photographs of tall ships parading through Boston Harbor, suggested an old confidence, a stolid view of the future, a disregard of money, even, that seemed to be a part of the firm’s character. Perhaps it was inevitable that it not last. Nothing lasts forever. But in Nibble’s case change came very abruptly indeed.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We underestimated Mrs. Buckles, when she first arrived, the associates did. We all assumed that she was just another in a series of office managers the firm seemed to dabble in from time to time. They’d arrive filled with high ideals and complex plans but the firm’s inertia kicked in each time leaving everyone free to continue doing things pretty much as they always had. Eventually, buried somewhere in a notice, we’d learn that the new manager had left “to pursue other opportunities” and the subdued tone of it always suggested just a tinge of ignominy. A hundred and ten years of doing things a certain way creates all sorts of habits that are hard to break.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This time it was different. For one thing it was obvious that Mrs. Buckles had far more authority than the hapless procession that had preceded her. Not only did she call Tony Olwine, the firm’s gruesome managing partner, “Tony,” forcefully and without a hint of self consciousness, but instead of being stuck off in a corner with the accounting types and the title examiners she had her own partner-sized office right next door to Olwine’s, even her own secretary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“A secretary with a secretary?” Lioce mused when he heard it. “Do the lawyers get lawyers?”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("To be fair, perhaps the firm’s old ways were a touch archaic, but almost overnight it was as if a team of strangers had landed on us with the single-minded mission of jettisoning all traces of the past. At one time the firm’s only visible bureaucrat was a dear old thing who was rumored to have known the original Mr. Nibble. Stuck in a cubicle that always smelled somehow of ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("powder, she handled everything from petty cash to Blue Cross forms, and even if she couldn’t answer the simplest question, or more accurately could, but not correctly, there was something endearing about her. And then, without notice, she was gone, replaced by a swarm of “staffers” each of whom, or so it seemed, was tasked with a small corner of what the old dear had once mishandled. There was no being stuck in a cubicle for this lot either. They were everywhere, usually following Mrs. Buckles about like a line of ducklings.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That we would be moving as well began as a rumor, but eventually it was confirmed and once it was not a day passed without a memorandum or two from someone on Mrs. Buckles’s staff revealing some innovation or other that would greet us in our new offices. It was as if these people, whom we’d never seen until three months before, had actually invented "), _c('em', [_vm._v("us")]), _vm._v(", as if without them we had scarcely existed. I suppose change is always hard, but there was something particularly unsettling about how eagerly the firm’s management seemed to embrace it. Rumor had it—there was always an associate who had been in a partner’s office and overheard something, or a confidential memorandum lying indiscreetly somewhere—that the offices into which we were moving were very lavish indeed. One couldn’t help but be apprehensive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was actually in Mrs. Buckles’s office once. She wasn’t there, but I was passing by and looked in. I saw a piece of calligraphy she has hanging on the wall behind her desk. It read:")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_c('em', [_vm._v("None of us is smarter than all of us.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I must admit that I disagreed with every single syllable of that notion. I mean, hasn’t Communism been discredited?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Maria had problems of her own with Mrs. Buckles and I suppose they were trivial, but it does seem to me that if you take a whole lot of trivial things together they can, in the end, add up to something that is less than, or more than, trivial.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They changed my chair overnight,” she said one morning, “because the old one doesn’t meet some sort of fire code. But the new one doesn’t fit under my desk. The arms are too high. If I don’t sit right on the edge of it I can barely reach the keyboard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It’s not exactly death or famine, as I say, but if it irked her it irked her. She did, after all, sit in the darn thing all day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you perfectly sure you’re not overreacting?” I said. “You do have to pick your battles in this world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mrs. Buckles’s minions insist that it’s a regulation chair and a regulation desk. So I took one of them across the hall and showed them a chair that slid under a desk and she said she’d look into it. That was the last I heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We could cut an inch off the legs,” I said. “I’ll bring a saw.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’d cut your hands off before you did any damage to the chair,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I started to leave but this simple act was always difficult for me. The air in her office held me back. Sometimes I felt as if I was bending backwards as my legs carried me away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“May I make a comment, Mr. Dover?” Kay had said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t think it seemly that the new associate, Maria, spends as much time in your office as she does. People will notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s perfectly innocent, Kay,” I told her, trying to think of what I could say that might convey some reason for my strong interest in this new lawyer without conveying too much. “She’s an interesting person, you know. She studied art history at Harvard and spends every summer in Spain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Be that as it may, Mr. Dover,” Kay said, clearly not convinced. “I’m talking about appearances. This is not the year to ignore that aspect of things.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v(" “Don’t worry, Kay,” I told her. “Nobody even notices.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ve been around offices a long time,” Kay insisted. “I wouldn’t say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My phone rings. It is Tony Olwine, thin lipped, elegant, silver haired. It is a fairly firm rule of thumb among the associates that it is never good news to hear from Tony Olwine. He is too powerful, too acerbic, too critical, for an associate to emerge unscathed from just about any encounter with him. If he calls, it is because there is a typographical error in a letter to one of his clients, or something in a brief that he happens not to like.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I would like to see you in my office,” Olwine says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He never identifies himself when he calls, simply assumes you recognize his voice. On the phone he sounds younger than he is, not at all menacing, if you disregard what he is saying, that is. The voice is always calm, boyish, very precise. I once heard John Updike on the radio. Olwine’s a dead ringer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Now?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Unless you have something more pressing,” he responds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is classic Olwine. His answer contemplates that there might be something more pressing than answering his summons, but that this is inconceivable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll be right up,” I say as a sense of foreboding engulfs me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Where are you going?” Kay calls after me as I take my jacket off a hanger behind the door. “If you leave your office without telling me where you’re going and someone calls for you, you make me look very foolish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mr. Olwine,” I say, and she leaves it at that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Stan’s office is next to mine and as I pass he calls me in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I heard that,” he says. “What does he want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Who knows?” I say.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("As I turn to go I see in his face a trace of concern. It’s impossible to ignore how close Stan and I are to the partnership ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("decision. At this point, despite all the years of work, an ostensibly innocuous event could take one of us over the top, or just as easily sink us. I’m not in competition with Stan. I couldn’t be. And yet, by definition, I am.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Who knows what Olwine wants from me. If I knew I’d tell Stan and put him out of his misery. But I don’t know so I can’t.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aecdfe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Chapter01.vue
// module id = 72
// module chunks = 0